import WidgetView from '../widget-view'
import ReportWidgetConfig from './report-widget-config'
import _ from 'lodash'
import template from './report-widget-view.hbs'
import reportsMeta from 'scoreboard/reports/reports-meta'
import LoadingDots from 'scoreboard/components/loading-dots'
import togglePrefixedClass from 'scoreboard/components/toggle-prefixed-class'
import { filterAppliesToDataset } from '../maestro'
import unwrapModel from 'scoreboard/components/unwrap-model'
import $ from 'jquery'


var ReportWidgetView = WidgetView.extend({
	className: 'widget report',
	resizable: true,
	lockedAR: false,

	nonFetchProperties: ['label', 'reportId', 'reportSubtypeId', 'showHeaders']
		.concat(WidgetView.prototype.nonFetchProperties),

	initialize: function (opt) {
		WidgetView.prototype.initialize.apply(this, arguments)

		this.on('change:period', this._onPeriodChange.bind(this))
		this.model.on('change:report', () => {
			// Needed because canvas history will only use the set method - and that
			// does not update the direct property.
			this.model.report.set(this.model.get('report'), { parse: true })
			this.render()
		})
		this.model.properties.on('change:showHeaders', () => {
			this.results.options.showHeaders = this.isShowingHeaders()
			this._renderResults()
		})
	},

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		togglePrefixedClass(this.el, 'font-size', this.model.properties.get('fontSize'))

		if (this.$('.content').length === 0) {
			this.$el.append(template())

			this.loadingDots = new LoadingDots({el: this.$('.loading-dots-container')[0]}).render()

			// The dimensions are fixed, so it's safe to display this now with loading dots. But we don't want the export
			// to run until the results are displayed
			this.readyForDisplay()
		}

		if (this.model.report) {
			// If the report widget model has a report model, we can fetch the
			// report results and render them
			// #52454 need to wait until nextTick, because when canvas renders
			// this widget view, this.maestro() hasn't been set yet
			process.nextTick(() => this.fetch())
		} else {
			// #26787 if the report widget model doesn't have a report model yet
			// (like when undoing a deletion, before the dashboard /data fetch is done),
			// just render loading dots and wait until the fetch is complete
			this.loadingDots.render()

			this.listenToOnce(this.model.data, 'change', () => {
				this.model.initializeReportModel(this.canvas.collection.options)
				this.render()
			})
		}

		this.renderTitle()

		return this
	},

	fetch () {
		var reportWidget = this.model
		var report = reportWidget.report

		if (this.model.initialState) {
			let sort = this.model.initialState.sort
			if (sort) {
				report.set(sort)
			}
		}

		this.updateLiveFilters(report)

		let def = report.fetch({
			data: {results: true, showCount: true},
			embeddedToken: this.canvas.embeddedToken
		})
		if (this._reportFetchDef !== def) {
			this._reportFetchDef = def
			this._reportFetchDef.then(function (model) {
				var ResultView = reportsMeta[model.get('subtype')].results.extend({
					renderNoResultsMessage: (message) => {
						// Add .no-results-message class at the top for styling purposes
						this.$el.addClass('no-results-message')

						// Nix the .table-hack-cell wrapper bc there's no need for it
						// here and it breaks the layout
						this.$('.table-hack-cell').replaceWith(this.$('.scroll-container'))

						// We don't need this class either, there's no table
						this.$('.panel').removeClass('panel-with-table')

						// #13227 for dashboard report widgets, we want to leave the panel header alone and just
						// replace the table with the message. Make sure there's no .panel-content before inserting the
						// empty message, if there is, replace it.
						if (this.$('.panel-content').length > 0) {
							this.$('.panel-content').replaceWith(`<div class="panel-content"><div class="center vertical horizontal">${message}</div></div>`)
						} else {
							this.$('table').replaceWith(`<div class="panel-content"><div class="center vertical horizontal">${message}</div></div>`)
						}
					}
				})

				//#42080 reuse the results view on fetch
				if (!this.results) {
					this.results = new ResultView({
						model: model,
						parent: this,
						el: this.$('.results-container')[0],
						showLabel: false,
						showHeaders: this.isShowingHeaders(),
						disabled: this.disabled(),
						dashboardWidget: true,
						// We need to prevent the tooltip-and-details tooltip from
						// showing when we hover over table cells while the canvas is editable.
						preventTooltip: () => this.canvas.className == 'editable-canvas'
					})
				} else {
					this.results.options.disabled = this.disabled()
					this.results.options.showHeaders = this.isShowingHeaders()
				}

				this._renderResults()

				if (reportWidget.properties.get('reportId')) {
					// This is the initial rendering from adding the report widget.

					// Set the metadata on the report widget so that it can be saved later
					reportWidget.report = model
					reportWidget.set('report', model.attributes)

					// Clear out any IDs so that a new copy of the metadata will be saved
					// Need to do it silently on the report widget model or it will trigger
					// an unnecessary re-render
					reportWidget.properties.unset('reportId', {silent: true})
					delete reportWidget.get('properties').reportId

					model.unset('id')
					model.unset('subtypeId')
				}

				// The only report setting that the user can change is columns (specifically columns.range),
				// so only update the report when that changes
				reportWidget.report.on('change:columns', this.renderReport.bind(this))

				// Add a selector to the container for targeted styling
				this.$el.addClass('report-widget-' + model.get('subtype'))

				this.readyForExport()

				this.resize()

				// #52494 make sure the widget's DashboardData has this report's dataset
				let ds = unwrapModel(this.model.report?.get('dataset'))
				if (ds) {
					this.model.data.datasets(ds.id, ds)
				}
			}.bind(this)).catch((err) => {
				// #57674
				// If the report fetch fails, clear the loading dots and show
				// the empty state with the returned error message
				this.loadingDots.clear()
				const errXhr = err?._xhrErr?._xhr
				const responseJSON = errXhr?.responseJSON
				const hasPermissionsError = errXhr?.status === 403
				this.toggleEmptyState(responseJSON, {
					container: $(this.el),
					// #60083 - use 'locked' icon, not 'lock'
					icon: hasPermissionsError ? 'locked' : 'dataset-has-error',
					widgetType: 'report',
					showErrorTooltip: true,
					forceIsShort: true
				})
			})
		}
	},

	updateLiveFilters (report) {
		let maestro = this.model.maestro()

		const allFilters = _(maestro.liveFilters())
			.values()
			.flatten()
			.value()

		let applicableFilters
		let subjectDatasetId = report.get('dataset')?.id
		if (subjectDatasetId) {
			applicableFilters = allFilters.filter(filter =>
				filterAppliesToDataset({
					dashboardData: this.model.data,
					subjectDatasetId,
					filter
				})
			)
		} else {
			applicableFilters = []
		}

		// #42621 don't override the report model's filters property.
		// Instead, set "liveFilters" on it that it knows to use to
		// append to its configured filters when running its query.
		report.liveFilters?.(applicableFilters.map(f => {
			// Set liveFilters to all be -1 linkGroup so that they don't collide
			// with linkGroups on the configured report filters
			return filterWithNegatedLinkGroup(f)
		}))
	},

	isShowingHeaders: function() {
		return this.model.properties.get('showHeaders') != false
	},

	renderTitle: function() {
		const label = this.model.properties.get('label')
		if (label) {
			this.$('.title-text h3').html(label)
		}

		this.$el.toggleClass('has-title', !!label)
	},

	_onPeriodChange: function () {
		// only re-render report if the report has a period selected
		// #26594 or if it's a sql console report. They don't have period selectors,
		// but they can have variables in the SQL that reference the global period
		if (this.model.report.periodSelector || this.model.properties.get('reportSubtype') === 'sql-console') {
			this.renderReport()
		}
	},

	renderReport: function () {
		this.loadingDots.render()
		this.$el.addClass('is-loading')

		// Re-render report when period or options change
		this.model.report.fetch({data: {results: true}}).then(function (model) {
			this._renderResults()
		}.bind(this))
	},

	_renderResults: function () {
		this.loadingDots.clear()
		this.$el.removeClass('is-loading')
		if (!_.isNil(this.results)) {
			// #46768 if this has a table view with a stream, we need to clear
			// out the old stream before rendering new results
			_.invoke(this.results, 'tableView.resetStream')
			this.results.render()

			// If we're rendering a results view that has a table which needs to load
			// data, wait for it to finish loading/rendering that data and then call
			// resize() in order to correctly set our overflow classes since they probably
			// weren't set correctly before the data table was rendered.
			if (!_.isNil(this.results.tableView)) {
				this.results.tableView.on('dataRendered', () => this.resize())
			}
			// Some results views don't use an explicite tableView. When they're done
			// rendering they emit a 'ready' event.
			this.results.on('ready', () => this.resize())
		}

		// Here, we want to unwrap the results table from it's usual
		// .table-hack wrappers because we dont need those here in the WOB
		this.$('.scroll-container').appendTo(this.$('.results-container'))
		this.$('.table-hack-cell').remove()
	},

	_createConfigView: function () {
		return new ReportWidgetConfig({
			model: this.model,
			canvas: this.canvas,
			widgetUpdater: this.widgetUpdater
		})
	},

	resize: function() {
		// If the widget already has .is-overflowing-x/y, remove those classes
		// to start anew when we calculate overflow
		this.$el.removeClass('is-overflowing-x is-overflowing-y')

		let overflowY = this.isOverflowingY(this.$('.panel'))
		let overflowX = this.isOverflowingX(this.$('.panel'))
		this.$el.toggleClass('is-overflowing-y', overflowY)
		this.$el.toggleClass('is-overflowing-x', overflowX)
	},

	disable(disable) {
		this.results && this.results.disable && this.results.disable(disable)
	},

	/**
	 * @override
	 */
	getState: function (options) {
		if (this.results) {
			return this.results.getState(_.extend({isWob: true}, options))
		} else {
			return {}
		}
	},

	remove: function () {
		WidgetView.prototype.remove.apply(this, arguments)
		_.invokeMap([this.results, this.loadingDots], 'remove')
	}
})

function filterWithNegatedLinkGroup(f) {
	if (_.isNil(f.linkGroup)) {
		return _.clone(f)
	}

	return _.extend({}, f, { linkGroup: -1 * f.linkGroup })
}

export default ReportWidgetView
export { filterWithNegatedLinkGroup }

ReportWidgetView.__filename__ = 'dashboards/widgets/report/report-widget-view.js'
